import React from 'react';
import "./blackbtn.css"

const Blackbtn = (props) => {
    return ( 
        <>
            <button className={props.css1}>{props.name}</button>
        
        </>
     );
}
 
export default Blackbtn;